import { COLORS } from "components/v3/Theme/colors";
import { PATHS } from "constants/pathConstants";

const contactLinkStyle = { color: COLORS.WHITE };

export const legalNameTooltip = (
  <span>
    <p>
      <strong>Why is my name not editable?</strong>
    </p>
    <p>
      If your membership is through your employer benefits, your legal name was
      provided by your employer. Please contact your HR Benefits team to correct
      it.
    </p>
    <p>
      If your membership was purchased directly through Genomic Life, we need to
      speak with you to update your name. Please{" "}
      <a
        href={PATHS.HELP_CENTER_CONTACT_US}
        rel="noopener noreferrer"
        style={contactLinkStyle}
        target="_blank"
      >
        call us
      </a>{" "}
      to make a change.
    </p>
  </span>
);

export const dateOfBirthTooltip = (
  <span>
    <p>
      <strong>Is your date of birth not correct?</strong>
    </p>
    <p>
      If your membership is through your employer benefits, your date of birth
      was provided by your employer. Please contact your HR Benefits team to
      correct it.
    </p>
    <p>
      If your membership was purchased directly through Genomic Life, please{" "}
      <a
        href={PATHS.HELP_CENTER_CONTACT_US}
        rel="noopener noreferrer"
        style={contactLinkStyle}
        target="_blank"
      >
        contact us
      </a>
      .
    </p>
  </span>
);
